<template lang="pug">
#report-sales-taxes
    v-banner.title-banner(min-height="88")
        .text-h4.font-weight-bold {{ $t('Menu.__Report') }} : {{ $t('Reports.__TrialBalance') }}
        //- template(v-slot:actions)
        //-     v-btn.my-2.ml-4(rounded dark @click="downloadReport" color="primary") 
        //-         | {{$t('ActionOption.__Export')}}
    v-container
        v-card(color="#fdf1eb", elevation="0")
            v-card-text
                v-form(v-model="formValid", ref="reportform")
                    v-row
                        v-col(cols="12", md="3")
                            v-menu(
                                v-model="endDateMenu",
                                offset-y,
                                :close-on-content-click="false",
                                :nudge-right="40",
                                transition="scale-transition",
                                min-width="290px"
                            )
                                template(v-slot:activator="{ on }")
                                    v-text-field(
                                        v-model="endDate",
                                        clearable,
                                        solo,
                                        dense,
                                        outlined,
                                        readonly,
                                        append-icon="event",
                                        v-on="on",
                                        :placeholder="$t('Placeholder.__Date')",
                                        :rules="[rules.required]"
                                    )
                                v-date-picker(
                                    v-model="endDate",
                                    @input="endDateMenu = false",
                                    :locale="$store.getters['account/language']() == 'tw' ? 'zn-tw' : ''"
                                )
                        v-col.text-right
                            v-btn(rounded, dark, @click="generateReport", color="primary", min-width="112") {{ $t('Reports.__GenerateReport') }}
        v-row(v-if="reportData")
            v-col.text-right.mx-4
                v-btn.ml-4(rounded, dark, color="#b4b9be", @click="downloadReportExcel") 
                    | {{ $t('ActionOption.__Export') }} EXCEL
                v-btn.ml-4(rounded, dark, color="#b4b9be", @click="downloadReportPDF") 
                    | {{ $t('ActionOption.__Export') }} PDF
        v-card#report-data.mt-4(v-if="reportData")
            v-card-text
                v-row
                    v-col(cols="12")
                        v-simple-table.report-table(dense)
                            template(v-slot:default)
                                thead
                                    tr
                                        th {{ $t('Reports.__AccountName') }}
                                        th.text-right {{ $t('Reports.__Debit') }}
                                        th.text-right {{ $t('Reports.__Credit') }}
                                tbody
                                    template(v-for="group in accountGroups")
                                        tr(style="background-color: #fdf1eb")
                                            td(colspan="3") {{ $t('AccountGroups.__' + group) }}
                                        tr(v-for="account in reportData[group]")
                                            td 
                                                router-link(:to="getAccountTransactionUrl(account)", target="_blank")
                                                    .ml-2.primary--text {{ getAccountTranslatedName(account.name) }}
                                            td.text-right {{ getAmountWithCurrency(account.debit, currencyCode) }}
                                            td.text-right {{ getAmountWithCurrency(account.credit, currencyCode) }}
                                        tr(v-if="groupTotal[group]")
                                            td.font-weight-bold {{ groupTotal[group].name }}
                                            td.text-right.font-weight-bold {{ getAmountWithCurrency(groupTotal[group].debit, currencyCode) }}
                                            td.text-right.font-weight-bold {{ getAmountWithCurrency(groupTotal[group].credit, currencyCode) }}
                                        tr.no-hover
                                            td(colspan=3, style="border-bottom: 0px")

                                    tr(v-if="groupTotal['total']")
                                        td.font-weight-bold(style="border-bottom: 2px solid #e67339") {{ groupTotal['total'].name }}
                                        td.text-right.font-weight-bold(style="border-bottom: 2px solid #e67339") {{ getAmountWithCurrency(groupTotal['total'].debit, currencyCode) }}
                                        td.text-right.font-weight-bold(style="border-bottom: 2px solid #e67339") {{ getAmountWithCurrency(groupTotal['total'].credit, currencyCode) }}
</template>
<script>
import * as TimeHelper from "@/utils/timeHelper"
import * as accountHelper from "@/utils/accountHelper"
import * as textfieldUtils from "@/utils/textfield.js"
import * as CurrencyHelper from "@/utils/currencies"
import { Workbook, boldRowText } from "@/utils/excelFileHelper"
import * as pdfFileHelper from "@/utils/pdfFileHelper"

export default {
  mixins: [TimeHelper.mixin, accountHelper.mixin, CurrencyHelper.mixin],

  data() {
    return {
      title: this.$t("Reports.__TrialBalance"),
      currencyCode: "TWD",
      formValid: false,
      // dates: [],
      endDateMenu: false,
      endDate: null,
      reportData: null,
      rules: textfieldUtils.rules,
      paymentsAndBalancesTotal: {},
      salesAndPurchasesTotal: {},
      accountGroups: ["Assets", "Liabilities", "Income", "OperatingExpenses", "OperatingCosts", "OwnersEquity"],
      groupTotal: null,
      headers: [this.$t("Reports.__AccountName"), this.$t("Reports.__Debit"), this.$t("Reports.__Credit")]
    }
  },
  methods: {
    generateReport() {
      this.$refs.reportform.validate()
      if (!this.formValid) {
        return
      }
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("reports/getTrailBalance", {
          from: "1950-01-01",
          to: this.endDate
        })
        .then(
          function(response) {
            // this.reportData = response.data.accounts
            this.reportData = {}
            this.groupTotal = {}
            if (response.data.accounts) {
              for (var item of response.data.accounts) {
                if (this.reportData[item.group] == null) {
                  this.reportData[item.group] = []
                }
                this.reportData[item.group].push(item)
              }
            }

            // var total_debit = 0
            // var total_credit = 0

            for (var group of this.accountGroups) {
              var group_debit = 0
              var group_credit = 0
              if (this.reportData[group]) {
                for (var account of this.reportData[group]) {
                  group_debit += account.debit
                  // total_debit += account.debit
                  group_credit += account.credit
                  // total_credit += account.credit
                }
              }
              this.groupTotal[group] = {
                name: this.$t("Reports.__Total"),
                debit: group_debit,
                credit: group_credit
              }
            }
            this.groupTotal["total"] = {
              name: this.$t("Reports.__TotalForAllAccounts"),
              debit: response.data.total.debit,
              credit: response.data.total.credit
            }
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    downloadReportExcel() {
      var filename = this.filename + ".xlsx"
      const workbook = new Workbook()

      for (var group of this.accountGroups) {
        var sheetName = this.$t("AccountGroups.__" + group)
        var worksheet = workbook.addWorksheet(sheetName)
        worksheet.addRow([this.$store.getters["bizes/biz"]().name])
        worksheet = this.translate2ExcelData(worksheet, this.headers, group, this.reportData[group])
      }
      if (this.groupTotal["total"]) {
        var sheetNameTotal = this.groupTotal["total"].name
        var worksheetTotal = workbook.addWorksheet(sheetNameTotal)
        worksheetTotal.addRow([this.$store.getters["bizes/biz"]().name])
        boldRowText(worksheetTotal.addRow(this.headers))
        boldRowText(
          worksheetTotal.addRow([
            this.groupTotal["total"].name,
            this.getAmountWithCurrency(this.groupTotal["total"].debit),
            this.getAmountWithCurrency(this.groupTotal["total"].credit)
          ])
        )
      }

      workbook.download(filename)
    },
    translate2ExcelData(worksheet, headers, group, groupData) {
      boldRowText(worksheet.addRow(headers))
      for (var account of groupData) {
        var row = []
        row.push(this.getAccountTranslatedName(account.name))
        row.push(this.getAmountWithCurrency(account.debit))
        row.push(this.getAmountWithCurrency(account.credit))
        worksheet.addRow(row)
      }
      if (this.groupTotal[group]) {
        var totalRow = []
        totalRow.push(this.groupTotal[group].name)
        totalRow.push(this.getAmountWithCurrency(this.groupTotal[group].debit))
        totalRow.push(this.getAmountWithCurrency(this.groupTotal[group].credit))
        boldRowText(worksheet.addRow(totalRow))
      }

      return worksheet
    },
    downloadReportPDF() {
      var filename = this.filename + ".pdf"
      var content = []

      //pdf
      content.push(pdfFileHelper.pdfTitle(this.$store.getters["bizes/biz"]().name))

      var idx = 0
      for (var group of this.accountGroups) {
        if (idx == 0) content.push(pdfFileHelper.pdfHeader(this.title + " - " + this.$t("AccountGroups.__" + group)))
        else content.push(pdfFileHelper.pdfHeader(this.title + " - " + this.$t("AccountGroups.__" + group), true))
        content.push(this.endDate)
        var tableBody = this.translate2PDFData(Array.from(this.headers), group, this.reportData[group])
        content.push(pdfFileHelper.pdfTableSimple(tableBody))
        idx++
      }
      //total
      if (this.groupTotal["total"]) {
        content.push(pdfFileHelper.pdfHeader(this.title + " - " + this.$t("Reports.__TotalForAllAccounts"), true))
        content.push(this.endDate)
        var tableBodyTotal = []
        var tableHeadersTotal = []
        for (var header of this.headers) {
          tableHeadersTotal.push(pdfFileHelper.pdfTableHeader(header))
        }
        tableBodyTotal.push(tableHeadersTotal)
        tableBodyTotal.push([
          pdfFileHelper.pdfBoldText(this.groupTotal["total"].name),
          pdfFileHelper.pdfBoldText(this.getAmountWithCurrency(this.groupTotal["total"].debit, this.currencyCode)),
          pdfFileHelper.pdfBoldText(this.getAmountWithCurrency(this.groupTotal["total"].credit, this.currencyCode))
        ])
        content.push(pdfFileHelper.pdfTableSimple(tableBodyTotal))
      }

      pdfFileHelper.downloadPDF(filename, content, "landscape")
    },
    translate2PDFData(headers, group, groupData) {
      var tableBody = []
      var tableHeaders = []
      for (var header of headers) {
        tableHeaders.push(pdfFileHelper.pdfTableHeader(header))
      }
      tableBody.push(tableHeaders)

      for (var account of groupData) {
        var row = []
        row.push(this.getAccountTranslatedName(account.name))
        row.push(this.getAmountWithCurrency(account.debit, this.currencyCode))
        row.push(this.getAmountWithCurrency(account.credit, this.currencyCode))
        tableBody.push(row)
      }
      if (this.groupTotal[group]) {
        var totalRow = []
        totalRow.push(pdfFileHelper.pdfBoldText(this.groupTotal["total"].name))
        totalRow.push(pdfFileHelper.pdfBoldText(this.getAmountWithCurrency(this.groupTotal[group].debit, this.currencyCode)))
        totalRow.push(pdfFileHelper.pdfBoldText(this.getAmountWithCurrency(this.groupTotal[group].credit, this.currencyCode)))
        tableBody.push(totalRow)
        console.log(totalRow)
      }

      return tableBody
    },
    // downloadReport() {
    //     if (this.reportData) {
    //         var filename =
    //             this.$t("Reports.__TrialBalance") +
    //             "_" +
    //             this.dates[0] +
    //             "_" +
    //             this.dates[1]
    //         this.$store.dispatch("global/startLoading")
    //         PDF.download("#report-data", filename, () => {
    //             this.$store.dispatch("global/stopLoading")
    //         })
    //     }
    // },
    getAccountTransactionUrl(account) {
      return (
        "/" +
        this.$route.params.lang +
        "/reports/account-transactions?from=beginning&to=" +
        this.endDate +
        "&accountid=" +
        account.id
      )
    }
  },
  computed: {
    dateRangeText() {
      return this.dates
        .slice()
        .sort()
        .join(" ~ ")
    },
    filename() {
      return this.title + "_" + this.endDate
    }
  },
  mounted() {
    var today = new Date()
    // this.dates = [
    //     "1950-01-01",
    //     this.getStringByFormat(today)
    // ]
    this.endDate = this.getStringByFormat(today)
    this.generateReport()
  },
  created() {
    this.currencyCode = this.$store.getters["bizes/currencyCode"]()
  }
}
</script>
<style lang="scss">
.report-table {
  .dark-col {
    background-color: #f5c7b0;
  }
}
a {
  text-decoration: none;
}
</style>
